window.auguste = window.auguste || {};
window.auguste.Tabs = ( function () {
    "use strict";

    // Ohne Schwelle schaltet ein Zug quer ueber die Leiste den Tab um, unter dem
    // man loslaesst.
    const DRAG_THRESHOLD = 5;

    const initialized = new WeakSet();

    // Leisten mit einer id merken sich ihren offenen Tab fuer die Dauer des
    // Browser-Tabs. Wiederhergestellt wird beim Initialisieren und ohne Klick,
    // sonst sieht man die fade-Blende der Bootstrap-Tabs.
    // Als Cookie, nicht im sessionStorage: so kennt der Server den offenen Tab
    // schon beim Rendern und die Seite kommt gleich richtig an.
    const COOKIE_PREFIX = 'ksb_tab_';

    const isScrollable = ( list ) => list.scrollWidth > list.clientWidth;

    const readOpenTab = ( list ) => {
        const wanted = COOKIE_PREFIX + list.id + '=';

        const hit = document.cookie.split( ';' )
            .map( ( entry ) => entry.trim() )
            .find( ( entry ) => entry.startsWith( wanted ) );

        return hit ? decodeURIComponent( hit.slice( wanted.length ) ) : null;
    };

    // Ohne expires ein Sitzungs-Cookie: es gilt, bis der Browser zugeht.
    const writeOpenTab = ( list, id ) => {
        document.cookie = COOKIE_PREFIX + list.id + '=' + encodeURIComponent( id )
            + ';path=/;SameSite=Lax';
    };

    const activate = ( list, button ) => {
        list.querySelectorAll( '[data-bs-target]' ).forEach( ( other ) => {
            const on = other === button;

            other.classList.toggle( 'active', on );
            other.setAttribute( 'aria-selected', on ? 'true' : 'false' );

            const pane = document.querySelector( other.getAttribute( 'data-bs-target' ) );
            if ( pane ) {
                pane.classList.toggle( 'show', on );
                pane.classList.toggle( 'active', on );
            }
        } );

        button.dispatchEvent( new CustomEvent( 'shown.bs.tab', { bubbles: true } ) );
    };

    const rememberOpenTab = ( list ) => {
        if ( !list.id ) {
            return;
        }

        list.addEventListener( 'shown.bs.tab', ( event ) => {
            const item = event.target.closest && event.target.closest( '[data-bs-target]' );
            if ( item && item.id ) {
                writeOpenTab( list, item.id );
            }
        } );

        const stored = readOpenTab( list );
        if ( !stored ) {
            return;
        }

        const button = [ ...list.querySelectorAll( '[data-bs-target]' ) ]
            .find( ( item ) => item.id === stored );

        if ( button && !button.classList.contains( 'active' ) ) {
            activate( list, button );
        }
    };

    const initList = ( list ) => {
        if ( initialized.has( list ) ) {
            return;
        }
        initialized.add( list );

        rememberOpenTab( list );

        let pointer_id   = null;
        let start_x      = 0;
        let start_scroll = 0;
        let dragged      = false;

        const refresh = () => {
            list.classList.toggle( 'uds-tabs__list--draggable', isScrollable( list ) );
        };

        refresh();
        window.addEventListener( 'resize', refresh );

        const stopDragging = () => {
            if ( pointer_id === null ) {
                return;
            }

            if ( list.hasPointerCapture( pointer_id ) ) {
                list.releasePointerCapture( pointer_id );
            }

            pointer_id = null;
            list.classList.remove( 'uds-tabs__list--dragging' );
        };

        list.addEventListener( 'pointerdown', ( event ) => {
            if ( event.pointerType !== 'mouse' || event.button !== 0 ) {
                return;
            }

            if ( !isScrollable( list ) ) {
                return;
            }

            pointer_id   = event.pointerId;
            start_x      = event.clientX;
            start_scroll = list.scrollLeft;
            dragged      = false;

            // Pointer Capture erst ab der Schwelle: es leitet auch das folgende
            // click-Event auf die Liste um, ein Klick erreicht den Tab dann nicht.
        } );

        list.addEventListener( 'pointermove', ( event ) => {
            if ( event.pointerId !== pointer_id ) {
                return;
            }

            // Ging das pointerup ausserhalb der Leiste verloren, wuerde die Maus
            // sonst ohne gedrueckte Taste weiterziehen.
            if ( event.buttons === 0 ) {
                dragged = false;
                stopDragging();
                return;
            }

            const distance = event.clientX - start_x;

            if ( !dragged && Math.abs( distance ) < DRAG_THRESHOLD ) {
                return;
            }

            if ( !dragged ) {
                dragged = true;
                list.classList.add( 'uds-tabs__list--dragging' );
                list.setPointerCapture( pointer_id );
            }

            list.scrollLeft = start_scroll - distance;
            event.preventDefault();
        } );

        list.addEventListener( 'pointerup', ( event ) => {
            if ( event.pointerId === pointer_id ) {
                stopDragging();
            }
        } );

        list.addEventListener( 'pointercancel', ( event ) => {
            if ( event.pointerId === pointer_id ) {
                dragged = false;
                stopDragging();
            }
        } );

        // Nach einem Zug den Klick schlucken.
        list.addEventListener( 'click', ( event ) => {
            if ( !dragged ) {
                return;
            }

            dragged = false;
            event.preventDefault();
            event.stopPropagation();
        }, true );

        list.addEventListener( 'click', ( event ) => {
            const item = event.target.closest( '.uds-tabs__item' );

            if ( !item ) {
                return;
            }

            item.scrollIntoView( {
                inline: 'nearest',
                block: 'nearest',
                behavior: window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ? 'auto' : 'smooth',
            } );
        } );
    };

    const init = ( selector = '.uds-tabs__list' ) => {
        document.querySelectorAll( selector ).forEach( initList );
    };

    return { init };
} )();
